import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

import SurveyViewsTable from "@/domains/survey-views/components/SurveyViewTable";
import BaseButton from "@/components_v2/Button/BaseButton";
import { Roles } from "@/shared/utils/constants";
import { useSurveyViewPermissions } from "@/domains/survey-views/hooks/useSurveyViewPermissions";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { BUTTON_SIZES, BUTTON_TYPES } from "@/components_v2/Button/constants";

import "./styles.css";

const SurveyViewList = () => {
  const { t } = useTranslation();

  const currentUser = useSelector(selectCurrentUser);
  const { canCreate } = useSurveyViewPermissions(null, currentUser);

  const defaultFilters = useMemo(() => {
    if (currentUser) {
      if (currentUser.role === Roles.ADMIN.value) {
        return {};
      }
      return {
        organization: currentUser.organization?.id,
      };
    }
  }, [currentUser]);

  return (
    <div className="survey-view-list-container">
      <div className="survey-view-list-header">
        <h1 className="header-l-medium">
          {t("surveyViews.labels.publishAndShare")}
        </h1>
        {canCreate && (
          <BaseButton
            size={BUTTON_SIZES.SMALL}
            leadingIcon={<PlusOutlined />}
            to={"/reports/views/form"}
            type={BUTTON_TYPES.LINK}
          >
            {t("surveyViews.labels.generateNewSurveyView")}
          </BaseButton>
        )}
      </div>
      {defaultFilters && (
        <SurveyViewsTable
          columnNames={[
            "title",
            "publicationDestination",
            "dataFormat",
            "survey",
            "createdAt",
            "actions",
          ]}
          filterNames={["search", "survey", "dataFormat", "distributionFormat"]}
          defaultFilters={defaultFilters}
        />
      )}
    </div>
  );
};

export default SurveyViewList;
